import { render, staticRenderFns } from "./UploadsSelectV2.vue?vue&type=template&id=4c04efde"
import script from "./UploadsSelectV2.vue?vue&type=script&lang=js"
export * from "./UploadsSelectV2.vue?vue&type=script&lang=js"
import style0 from "./UploadsSelectV2.vue?vue&type=style&index=0&id=4c04efde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports